// extracted by mini-css-extract-plugin
export default {"image":"picture-module__image___748154","wrapper":"picture-module__wrapper___8c298a"};